import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const downloadThenRedirect: (downloadUrl: string, redirectTo?: string) => CanActivateFn =
    (downloadUrl, redirectTo?) => () => {
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = downloadUrl.split('/').at(-1);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        if (typeof redirectTo === 'string') {
            return inject(Router).parseUrl(redirectTo);
        }
    };
